import React, { useState } from 'react';
import { X, Info, Hash } from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';

const CreatePOModal = ({ isOpen, onClose, prData, onComplete }) => {
  const [ponum, setPonum] = useState('');
  const [description, setDescription] = useState(prData?.description || '');
  const [loading, setLoading] = useState(false);

  // دالة توليد رقم تلقائي (Autonumber)
  const handleAutonumber = async () => {
    try {
      const res = await axios.get(`/api/po/next-number/${prData.orgid}`);
      setPonum(res.data.next_ponum);
    } catch (err) { toast.error("Failed to get autonumber"); }
  };

  const handleConfirm = async () => {
    if (!ponum) return toast.error("Please enter or generate a PO number");
    setLoading(true);
    try {
      await axios.post('/api/pr/generate-po', {
        prnum: prData.prnum,
        ponum: ponum,
        orgid: prData.orgid
      });
      toast.success(`PO ${ponum} Created Successfully!`);
      onComplete(ponum); // نبعت الرقم عشان نعمل navigate
    } catch (err) {
      toast.error(err.response?.data?.detail || "Generation Failed");
    } finally { setLoading(false); }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white w-[600px] shadow-2xl border rounded-sm overflow-hidden animate-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="bg-[#f3f4f6] p-3 border-b flex justify-between items-center">
          <span className="font-bold text-gray-700 text-sm uppercase">Create PO</span>
          <button onClick={onClose} className="hover:text-red-500"><X size={18}/></button>
        </div>

        <div className="p-6">
          {/* Blue Info Box - زي ماكسيمو بالظبط */}
          <div className="flex gap-4 p-4 bg-blue-50 border border-blue-100 rounded-sm mb-6">
            <Info className="text-blue-600 shrink-0" size={24} />
            <p className="text-[12px] text-blue-900 leading-relaxed">
              Enter a purchase order number or generate one by clicking Autonumber. Click OK to create the purchase order.
            </p>
          </div>

          {/* Form Fields */}
          <div className="space-y-6">
            <div className="flex flex-col gap-1 group">
              <label className="text-[11px] font-bold text-gray-500 uppercase tracking-tighter">PO</label>
              <input 
                autoFocus
                className="border-b-2 border-blue-900 outline-none p-1 font-black text-blue-900 w-32 focus:border-orange-500 transition-all"
                value={ponum}
                onChange={(e) => setPonum(e.target.value.toUpperCase())}
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[11px] font-bold text-gray-400 uppercase tracking-tighter">Description</label>
              <input 
                className="border-b border-gray-300 outline-none p-1 font-bold text-gray-700 w-full"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="bg-gray-50 p-4 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-6 py-1.5 border border-blue-800 text-blue-800 font-bold hover:bg-blue-50">Cancel</button>
          <button onClick={handleConfirm} disabled={loading} className="px-8 py-1.5 bg-[#3c70a4] text-white font-bold hover:bg-blue-900 disabled:opacity-50">OK</button>
          <button onClick={handleAutonumber} className="px-6 py-1.5 border border-blue-800 text-blue-800 font-bold hover:bg-blue-50">Autonumber</button>
        </div>
      </div>
    </div>
  );
};

export default CreatePOModal;